import {Component, HostListener, OnInit, Pipe, PipeTransform, ViewChild, ViewEncapsulation} from '@angular/core';
import {FileSystemDirectoryEntry, FileSystemFileEntry, NgxFileDropComponent, NgxFileDropEntry} from 'ngx-file-drop';
import {ActivatedRoute} from '@angular/router';
import {RequestControllerService} from '../../services/request-controller.service';
import {Request} from '../../models/request';
import {InformationFieldsControllerService, UploadRequestUploadControllerService} from '../../services';
import {Configuration, MapLongObject, RequestUploads, UploadHandleWrapper} from '../../models';
import {MatTableDataSource} from '@angular/material/table';
import {UploadFile} from '../../upload-file';
import {FormControl} from '@angular/forms';
import {DropDownElement} from '../../drop-down-element';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslatePipe} from '../../translation/translate.pipe';
import {TranslateService} from '../../translation/translate.service';
import {DomSanitizer, SafeHtml, Title} from '@angular/platform-browser';
import {RequestFilePickerAdapter} from '../../request-file-picker.adapter';
import {HttpClient, HttpEvent, HttpEventType} from '@angular/common/http';
import {ApiConfiguration} from '../../api-configuration';
import {map} from 'rxjs/operators';
import {UtilityService} from '../../utility.service';
import {GetExtensionPipe, NumberFormatPipe, UploadTableComponent} from './upload-table/upload-table.component';
import {MatDialog} from '@angular/material/dialog';
import {DisclaimerDialogComponent} from './disclaimer-dialog/disclaimer-dialog.component';
import {UploadedDialogComponent} from './uploaded-dialog/uploaded-dialog.component';
import {PreConfiguration} from '../../models/pre-configuration';


@Pipe({name: 'sortFiles'})
export class SortFilesPipe implements PipeTransform {
  transform(value, sort, sortDirection): any {
    const sorted = value;
    if (sort === 'fileName') {
      if (sortDirection === 'desc') {
        sorted.sort((a, b) => this.compareFileName(b, a));
      } else {
        sorted.sort((a, b) => this.compareFileName(a, b));
      }
    }
    if (sort === 'changeDate') {
      if (sortDirection === 'desc') {
        sorted.sort((a, b) => this.compareLastModifiedFile(b, a));
      } else {
        sorted.sort((a, b) => this.compareLastModifiedFile(a, b));
      }
    }
    return sorted;
  }

  compareLastModifiedFile(a, b) {
    if (a.file.lastModified < b.file.lastModified) {
      return -1;
    }
    if (a.file.lastModified > b.file.lastModified) {
      return 1;
    }
    return 0;
  }

  compareFileName(a, b) {
    if (a.file.name < b.file.name) {
      return -1;
    }
    if (a.file.name > b.file.name) {
      return 1;
    }
    return 0;
  }
}

@Component({
  selector: 'app-request-page',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RequestComponent implements OnInit {
  request: Request;
  private id: string;
  private sub: any;
  public files: NgxFileDropEntry[] = [];
  dataSource;
  private uploadHandles: UploadHandleWrapper[] = [];
  uploadedFiles: UploadFile[] = [];
  @ViewChild('fileDrop', {read: NgxFileDropComponent, static: true}) fileDrop: NgxFileDropComponent;
  folderName;
  infoFields;
  valueOptions;
  selectizeConfigs;
  metadataAvailable = false;
  availabilityFromFormControl = new FormControl();
  availabilityToFormControl = new FormControl();
  folderControl;
  folderNameControl;
  folderOptions;
  folder;
  folderConfig = {
    create: false,
    valueField: 'id',
    labelField: 'name',
    delimiter: '|',
    maxItems: 1,
    minItems: 1,
    required: true,
    closeAfterSelect: true,
    searchField: 'name',
    render: {
      option(item) {
        let template = '<div>';
        if (item.parents) {
          item.parents.forEach(parent => {
            template += '<span class="parent-noderef">' + parent + ' - </span> ';
          });
        }
        template += '<span>' + item.name + '</span></div>';
        return template;
      }
    },
  };
  folderMode = 'CREATE_FOLDER';
  valid = true;
  currentlyUploaded = 0;
  loading = false;
  uploadingFile = 0;
  adapter: RequestFilePickerAdapter;
  targetNodeDeleted = false;
  sameMetadataEveryAsset = true;
  sortRenameConfig;
  @ViewChild('uploadTable', {static: false})
  uploadTable: UploadTableComponent;
  globalUploadedFile;
  metadataLanguages: any;
  defaultLanguage: string;
  urlPresetsMap = {};
  preConfiguration: PreConfiguration;
  createPinLink = false;
  folderUploaded = 0;
  autoUpload;
  autoUploadActivated = false;
  uploadedText = '';
  public uploaderInformation: SafeHtml;

  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if (this.uploadedFiles !== undefined && this.uploadedFiles !== null && this.uploadedFiles.length > 0 && this.loading === false) {
      $event.returnValue = 'Your data will be lost!';
    }
  }

  constructor(private route: ActivatedRoute,
              private requestService: RequestControllerService,
              private uploadService: UploadRequestUploadControllerService,
              private infoFieldsService: InformationFieldsControllerService,
              private snackBar: MatSnackBar,
              private translatePipe: TranslatePipe,
              public translateService: TranslateService,
              private titleService: Title,
              private http: HttpClient,
              private apiConfiguration: ApiConfiguration,
              private utilityService: UtilityService,
              private padFormattingPipe: NumberFormatPipe,
              private getExtensionPipe: GetExtensionPipe,
              private sortFilesPipe: SortFilesPipe,
              private dialog: MatDialog,
              public sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.requestService.getConfigUsingGET().subscribe(configuration => {
        this.translatePipe.transform('UPLOAD_SUCCESSFUL_HINT');
        this.preConfiguration = configuration;
        this.id = params.id;
        this.requestService.getRequestUsingGET(this.id).subscribe(res => {
        this.infoFieldsService.languagesUsingGET(res.configuration.language).subscribe(languages => {
          const urlPresetsString = this.route.snapshot.queryParamMap.get('infoValues');
          if (urlPresetsString) {
            const urlPresetsArray = urlPresetsString.split(',');
            urlPresetsArray.forEach(part => {
              const split = part.split(';');
              this.urlPresetsMap[split[0]] = split[1];
            });
          }
          this.metadataLanguages = languages['metadata'];
          this.defaultLanguage = languages['defaultLanguage'];
          this.uploadedText = languages['uploadedText'];
          this.targetNodeDeleted = !this.utilityService.getTargetNodeExists();
          this.adapter = new RequestFilePickerAdapter(this.http, this.id, this.apiConfiguration);
          this.request = res;
          // tslint:disable-next-line:max-line-length
          this.uploaderInformation = this.sanitizer.bypassSecurityTrustHtml(this.request.configuration.uploaderInformation[this.translateService.currentLang]);
          this.sameMetadataEveryAsset = this.preConfiguration.sameMetadataEveryAsset &&
              this.request.configuration.informationFields.length > 0;
          if (((this.preConfiguration.disclaimerEnabled && this.request.configuration.showDisclaimer) ||
              (!this.preConfiguration.disclaimerEnabled && this.preConfiguration.disclaimerDefault)) &&
            (((this.request.configuration.disclaimerTitleMap[this.request.configuration.language] &&
                  this.request.configuration.disclaimerTitleMap[this.request.configuration.language] !== '') ||
              (this.request.configuration.disclaimerTitleMap[this.translateService.currentLang]) &&
                this.request.configuration.disclaimerTitleMap[this.translateService.currentLang] !== '' ||
              (this.request.configuration.disclaimerTitleMap[this.defaultLanguage] &&
                this.request.configuration.disclaimerTitleMap[this.defaultLanguage] !== '')) &&
              ((this.request.configuration.disclaimerTextMap[this.request.configuration.language] &&
                  this.request.configuration.disclaimerTextMap[this.request.configuration.language] !== '') ||
                (this.request.configuration.disclaimerTextMap[this.translateService.currentLang] &&
                  this.request.configuration.disclaimerTextMap[this.translateService.currentLang] !== '') ||
                (this.request.configuration.disclaimerTextMap[this.defaultLanguage] &&
                  this.request.configuration.disclaimerTextMap[this.defaultLanguage] !== '')))) {
              this.dialog.open(DisclaimerDialogComponent,
                {
                  data: {
                    title: this.request.configuration.disclaimerTitleMap[this.request.configuration.language] ?
                      this.request.configuration.disclaimerTitleMap[this.request.configuration.language] :
                      (this.request.configuration.disclaimerTitleMap[this.translateService.currentLang] ?
                        this.request.configuration.disclaimerTitleMap[this.translateService.currentLang] :
                        this.request.configuration.disclaimerTitleMap[this.defaultLanguage]),
                    text: this.request.configuration.disclaimerTextMap[this.request.configuration.language] ?
                      this.request.configuration.disclaimerTextMap[this.request.configuration.language] :
                      (this.request.configuration.disclaimerTextMap[this.translateService.currentLang] ?
                        this.request.configuration.disclaimerTextMap[this.translateService.currentLang] :
                        this.request.configuration.disclaimerTextMap[this.defaultLanguage])
                  },
                  disableClose: true
                });
            }
          if (this.request.configuration.sortAndRename) {
              this.sortRenameConfig = {
                sort: 'fileName',
                sortDirection: 'asc',
                prefix: '',
                numberFormat: '01',
                startsWith: 0,
                suffix: '',
                addFileExtension: true
              };
            }
          this.titleService.setTitle(this.request.configuration.name);
          if (this.request.configuration.language != null) {
              this.translateService.use(this.request.configuration.language);
            }
          if (this.request.configuration.validTill != null && this.request.configuration.validTill > 0) {
              const now = new Date();
              now.setHours(0);
              now.setMinutes(0);
              now.setMinutes(0);
              now.setSeconds(0);
              now.setMilliseconds(0);
              this.valid = now <= new Date(this.request.configuration.validTill);
            } else {
              this.valid = true;
            }
          this.valueOptions = new Array(this.request.configuration.informationFields.length);
          this.selectizeConfigs = new Array(this.request.configuration.informationFields.length);
          if (this.request.configuration.assetType != null) {
              this.infoFieldsService.infoFieldsByAssetTypeForRequestUsingGET(this.request.id, this.request.configuration.assetType)
                .subscribe(infoFields => {
                  this.infoFields = infoFields;
                  this.request.configuration.informationFields.forEach((infoField, i) => {
                    let defaultValueFormControl = new FormControl();
                    if (infoField.kind === 'DROP_DOWN' || infoField.kind === 'NODE_REFERENCE') {
                      this.infoFieldsService.optionsByInfoFieldForRequestUsingGET(this.request.id, infoField.informationfieldId)
                        .subscribe(options => {
                          if (infoField.kind === 'DROP_DOWN') {
                            this.valueOptions[i] = options;
                            options.forEach(defaultValueOption => {
                              const defaultValueOptionOption = defaultValueOption as DropDownElement;
                              if (infoField.defaultValue === defaultValueOptionOption.key) {
                                defaultValueFormControl = new FormControl(defaultValueOption);
                              }
                            });
                          } else if (infoField.kind === 'NODE_REFERENCE') {
                            this.selectizeConfigs[i] = {
                              create: infoField.allowCreate && this.preConfiguration.createNoderefs
                                && (!this.preConfiguration.infofieldsAllowedCreateNoderefs
                                  || this.preConfiguration.infofieldsAllowedCreateNoderefs.indexOf(infoField.informationfieldId) > -1),
                              valueField: 'id',
                              labelField: 'name',
                              delimiter: '|',
                              maxItems: this.infoFields[infoField.informationfieldId] &&
                              this.infoFields[infoField.informationfieldId].max > 0 ?
                                this.infoFields[infoField.informationfieldId].max : null,
                              minItems: 0,
                              required: infoField.required,
                              closeAfterSelect: true,
                              searchField: 'name',
                              readOnly: infoField.locked,
                              render: {
                                option(item) {
                                  let template = '<div>';
                                  if (item.parents) {
                                    item.parents.forEach(parent => {
                                      template += '<span class="parent-noderef">' + parent + ' - </span> ';
                                    });
                                  }
                                  template += '<span>' + item.name + '</span></div>';
                                  return template;
                                }
                              },
                            };
                            let nodeRefoptions = [];
                            if (this.infoFields[infoField.informationfieldId] !== undefined &&
                              this.infoFields[infoField.informationfieldId].rootSelectable) {
                              options.forEach(defaultValueOption => {
                                nodeRefoptions = this.addChildOptions(nodeRefoptions, defaultValueOption, null, [], true);
                              });
                            } else {
                              options.forEach(defaultValueOption => {
                                const defaultValueOptionChild = defaultValueOption as any;
                                defaultValueOptionChild.children.forEach(child => {
                                  nodeRefoptions = this.addChildOptions(nodeRefoptions, child, null, [], true);
                                });
                              });
                            }
                            this.valueOptions[i] = nodeRefoptions;
                          }
                        });
                    } else {
                      if (infoField.kind === 'DATE') {
                        defaultValueFormControl.setValue(new Date(Number(infoField.defaultValue)));
                      }
                    }
                    this.metadataAvailable = this.metadataAvailable || !infoField.locked;
                  });
                });
            }
          if (this.request.configuration.saveMode === 'CHOOSE_FOLDER' || this.request.configuration.saveMode === 'CREATE_OR_CHOOSE') {
              this.folderControl = new FormControl();
              this.folderOptions = [];
              this.infoFieldsService.getFolderUsingGET(this.id).subscribe(options => {
                options.forEach(folderOption => {
                  this.folderOptions = this.addChildOptions(this.folderOptions, folderOption, null, [], false);
                });
                if (this.folderOptions.length === 1) {
                  this.folderControl.setValue(this.folderOptions[0].id);
                }
              });
            }
          this.folderNameControl = new FormControl();
          if (this.preConfiguration.autoUploadDefault) {
              this.autoUploadToggle();
            }
          });
        });

      });
    });
  }

  public dropped(files: NgxFileDropEntry[]) {
    if (!this.autoUpload || (this.isValid() && this.checkFolderValidity())) {
      if (this.request.configuration.maxFiles !== null &&
        (files.length + this.currentlyUploaded + this.request.uploadedFiles) > this.request.configuration.maxFiles) {
        this.snackBar.open(this.translatePipe.transform('TOO_MANY_FILES_1') +
          (this.request.configuration.maxFiles - this.currentlyUploaded - this.request.uploadedFiles) +
          this.translatePipe.transform('TOO_MANY_FILES_2'), 'Error', {
          duration: 5000,
        });
      } else {
        this.dataSource = new MatTableDataSource<UploadFile>(this.uploadedFiles);
        let toProcess = files.length;
        const errorMessages = [];
        for (const droppedFile of files) {
          const uploadFile = new class implements UploadFile {
            file: File;
            directoryEntry: FileSystemDirectoryEntry;
            fileEntry: FileSystemFileEntry;
            path: string;
            status: string;
            type: string;
            uploadHandle: string;
            duplicate: number;
            progress = 0;
            valueControls: FormControl[];
            configuration: Configuration;
          }();
          if (droppedFile.fileEntry.isFile) {
            const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
            fileEntry.file((file: File) => {
              if (file instanceof File) {
                if (this.request.configuration.maxFileSizeMB !== null
                  && parseInt((file.size / (1024 * 1024)).toFixed(0), 10) > this.request.configuration.maxFileSizeMB) {
                  errorMessages.push('File ' + file.name + ' is too big');
                } else if (this.request.configuration.fileCategory !== null
                  && !this.request.configuration.fileCategory.includes(this.getFileCategory(file.type))) {
                  this.files.splice(this.files.indexOf(droppedFile), 1);
                  errorMessages.push('File category of file ' + file.name + ' not allowed');
                } else if (this.request.configuration.maxFiles !== null &&
                  (this.request.uploadedFiles + this.currentlyUploaded) >= this.request.configuration.maxFiles) {
                  this.files.splice(this.files.indexOf(droppedFile), 1);
                } else {
                  uploadFile.type = 'file';
                  uploadFile.status = 'pending';
                  uploadFile.file = file;
                  uploadFile.configuration = JSON.parse(JSON.stringify(this.request.configuration));
                  this.uploadedFiles.push(uploadFile);
                  if (!this.globalUploadedFile) {
                    this.globalUploadedFile = uploadFile;
                  }
                  this.uploadingFile += 1;
                  this.uplaodFileToServerWithProgress(file.name, file, this.uploadedFiles.length - 1, fileEntry);
                  if (this.uploadTable) {
                    this.uploadTable.refresh();
                  }
                }
                toProcess -= 1;
                if (toProcess <= 0 && errorMessages.length > 0) {
                  this.snackBar.open('• ' + errorMessages.join('\n• '), 'Error', {
                    duration: 2000,
                    panelClass: ['multiline-snackbar']
                  });
                }
              } else {
                this.snackBar.open('Drag and drop doesn\'t in your browser', 'Error', {
                  duration: 2000,
                });
              }
            });
          }
        }
      }
    }
  }

  getFileCategory(mimeType) {
    if (mimeType.startsWith('image')) {
      return 'IMAGE';
    } else if (mimeType.startsWith('video')) {
      return 'VIDEO';
    } else if (mimeType.startsWith('audio')) {
      return 'AUDIO';
    } else if (mimeType.startsWith('text')) {
      return 'TEXT';
    } else if (mimeType.startsWith('application')) {
      return 'DOCUMENT';
    } else {
      return 'UNKNOWN';
    }
  }

  uplaodFileToServerWithProgress(name, file, index, fileEntry) {
    this.currentlyUploaded += 1;
    this.adapter.uploadFile({fileName: name, file}).pipe(
      map((res: HttpEvent<any>) => {
        if (res.type === HttpEventType.Response) {
          return res.body;
        } else if (res.type === HttpEventType.UploadProgress) {
          this.uploadedFiles[index].progress = +Math.round((100 * res.loaded) / res.total);
        }
      })
    ).subscribe(res => {
        if (res !== undefined) {
          this.onFileUploaded(index, res, fileEntry);
        }
      },
      (err) => {
        this.currentlyUploaded -= 1;
        this.onFileUploadFailed(index, fileEntry, err);
      });
  }



  applyInfofield(event: any) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.uploadedFiles.length; i++) {
      if (Array.isArray(this.uploadedFiles[i].valueControls[event.index])) {
        for (const key in this.uploadedFiles[i].valueControls[event.index]) {
          if (event.formControl[key]) {
            this.uploadedFiles[i].valueControls[event.index][key].setValue(event.formControl[key].value);
          }
        }
      } else {
        this.uploadedFiles[i].valueControls[event.index].setValue(event.formControl.value);
      }
    }
  }


  onFileUploaded(index, res, fileEntry) {
      this.uploadingFile -= 1;
      this.uploadedFiles[index].uploadHandle = res.identifier;
      if (this.autoUpload) {
        this.uploadedFiles[index].status = 'finishing';
      } else {
        this.uploadedFiles[index].status = 'uploaded';
      }
      this.uploadedFiles[index].progress = 100;
      this.uploadedFiles[index].fileEntry = fileEntry;
      this.uploadedFiles[index].duplicate = res.duplicates;
      if (this.request.configuration.duplicateStrategy !== 'DO_NOTHING' &&
        this.request.configuration.duplicateHandling === 'DO_NOTHING' && res.duplicates > 0) {
        this.currentlyUploaded--;
      }
      const uploadHandleWrapper = new class implements UploadHandleWrapper {
        fullPath: string;
        handleIdentifier: string;
        name: string;
        file: any;
      }();
      if (this.preConfiguration.folderUpload) {
        uploadHandleWrapper.fullPath = fileEntry['fullPath'];
        if (fileEntry['fullPath'] && (fileEntry['fullPath'].split('/').length - 1) > 1) {
          this.folderUploaded++;
        }
      } else {
        uploadHandleWrapper.fullPath = '/';
      }
      uploadHandleWrapper.fullPath = fileEntry['fullPath'];
      uploadHandleWrapper.name = fileEntry.name;
      uploadHandleWrapper.handleIdentifier = res.identifier;
      uploadHandleWrapper.file = this.uploadedFiles[index].file;
      this.uploadHandles.push(uploadHandleWrapper);
      if (this.autoUpload) {
        this.submitFile(index, res);
      }
  }

  onFileUploadFailed(index, fileEntry, err) {
    this.snackBar.open(this.translatePipe.transform(err.error.title) + ':\n' + this.translatePipe.transform(err.error.message),
      this.translatePipe.transform('ERROR'), {
        duration: 2000,
        panelClass: ['success-snackbar']
      });
    console.log(err);
    this.uploadingFile -= 1;
    this.uploadedFiles[index].status = 'failed';
    this.uploadedFiles[index].fileEntry = fileEntry;
  }

  checkFolderValidity() {
    if (this.request.configuration.saveMode === 'CREATE_FOLDER' ||
      (this.request.configuration.saveMode === 'CREATE_OR_CHOOSE' && this.folderMode === 'CREATE_FOLDER')) {
      if (!this.folderName || this.folderName === '') {
        this.folderNameControl.markAsTouched();
        this.folderNameControl.markAsDirty();
        this.snackBar.open('Please choose a target folder name', 'No target folder', {
          duration: 2000,
        });
        return false;
      } else {
        return true;
      }
    } else if (this.request.configuration.saveMode === 'CHOOSE_FOLDER' ||
      (this.request.configuration.saveMode === 'CREATE_OR_CHOOSE' && this.folderMode === 'CHOOSE_FOLDER')) {
      if (!this.folder) {
        this.folderControl.markAsTouched();
        this.folderControl.markAsDirty();
        this.snackBar.open('Please choose a target folder', 'No target folder', {
          duration: 2000,
        });
        return false;
      } else {
        return true;
      }
    }
  }

  prepareRequestUpload(identifier) {
    const requestUpload = new class implements RequestUploads {
      folderName: string;
      folderId: number;
      metadata?: Array<MapLongObject>;
      metadataMap?: Map<string, MapLongObject>;
      uplodHandles?: Array<UploadHandleWrapper>;
      createPinLink: boolean;
      availableFrom: number;
      availableTo: number;
    }();
    if (this.request.configuration.saveMode === 'CREATE_FOLDER' ||
      (this.request.configuration.saveMode === 'CREATE_OR_CHOOSE' && this.folderMode === 'CREATE_FOLDER')) {
      if (!this.folderName || this.folderName === '') {
        this.folderNameControl.markAsTouched();
        this.folderNameControl.markAsDirty();
        this.snackBar.open('Please choose a target folder name', 'No target folder', {
          duration: 2000,
        });
      } else {
        requestUpload.folderName = this.folderName;
      }
    } else if (this.request.configuration.saveMode === 'CHOOSE_FOLDER' ||
      (this.request.configuration.saveMode === 'CREATE_OR_CHOOSE' && this.folderMode === 'CHOOSE_FOLDER')) {
      if (!this.folder) {
        this.folderControl.markAsTouched();
        this.folderControl.markAsDirty();
        this.snackBar.open('Please choose a target folder', 'No target folder', {
          duration: 2000,
        });
      } else {
        requestUpload.folderId = this.folder;
      }
    }
    requestUpload.createPinLink = this.createPinLink && (this.folderUploaded === 0);
    if (this.availabilityFromFormControl && this.availabilityFromFormControl.value) {
      requestUpload.availableFrom = this.availabilityFromFormControl.value.valueOf();
    }
    if (this.availabilityToFormControl && this.availabilityToFormControl.value) {
      requestUpload.availableTo = this.availabilityToFormControl.value.valueOf();
    }
    requestUpload.metadata = [];
    if (identifier) {
      requestUpload.uplodHandles = this.uploadHandles.filter(u => u.handleIdentifier === identifier.identifier);
    } else {
      requestUpload.uplodHandles = this.uploadHandles;
    }
    if (this.sortRenameConfig) {
      this.sortFilesPipe.transform(this.uploadHandles, this.sortRenameConfig.sort, this.sortRenameConfig.sortDirection).forEach(
        (uploadHandle, i) => {
          uploadHandle.name =
            ((this.sortRenameConfig['prefix'] ? this.sortRenameConfig['prefix'] : '') +
              (this.padFormattingPipe.transform(i +
                this.sortRenameConfig['startsWith'], this.sortRenameConfig['numberFormat']))) +
            (this.sortRenameConfig['suffix'] ? (this.sortRenameConfig['suffix']) : '') +
            (this.sortRenameConfig['addFileExtension'] ?
              ('.' + (uploadHandle.name ? this.getExtensionPipe.transform(uploadHandle.name) : '')) : '');
        });
    }
    if (this.request.configuration.assetSpecificMetadata && !this.sameMetadataEveryAsset && !this.autoUpload) {
      this.uploadedFiles.forEach(uploadedFile => {
        const metadata = {};
        this.request.configuration.informationFields.forEach((infoField, i) => {
          if (infoField.kind === 'DATE') {
            metadata[infoField.informationfieldId] = uploadedFile.valueControls[i].value !== null ?
              uploadedFile.valueControls[i].value.valueOf() : null;
          } else if (infoField.kind === 'LOCALIZED_TEXT_AREA' || infoField.kind === 'LOCALIZED_TEXT') {
            const localizedValue: any = {values: {}};
            this.metadataLanguages.forEach(metadataLanguage => {
              localizedValue.values[metadataLanguage] = uploadedFile.valueControls[i][metadataLanguage].value;
            });
            metadata[infoField.informationfieldId] = localizedValue;
          } else if (infoField.kind === 'DROP_DOWN' && uploadedFile.valueControls[i].value != null) {
            metadata[infoField.informationfieldId] = uploadedFile.valueControls[i].value.key;
          } else {
            metadata[infoField.informationfieldId] = uploadedFile.valueControls[i].value;
          }
        });
        if (!requestUpload.metadataMap) {
          requestUpload.metadataMap = new Map();
        }
        requestUpload.metadataMap[uploadedFile.uploadHandle] = metadata;
        requestUpload.metadata.push(metadata);
      });
    } else {
      const metadata = {};
      let valueControls;
      if (this.request.configuration.assetSpecificMetadata && !this.autoUpload) {
        valueControls = this.uploadedFiles[0].valueControls;
      } else {
        valueControls = this.globalUploadedFile.valueControls;
      }
      this.request.configuration.informationFields.forEach((infoField, i) => {
        if (infoField.kind === 'DATE') {
          metadata[infoField.informationfieldId] = valueControls[i].value !== null ?
            valueControls[i].value.valueOf() : null;
        } else if (infoField.kind === 'LOCALIZED_TEXT_AREA' || infoField.kind === 'LOCALIZED_TEXT') {
          const localizedValue: any = {values: {}};
          this.metadataLanguages.forEach(metadataLanguage => {
            localizedValue.values[metadataLanguage] = valueControls[i][metadataLanguage].value;
          });
          metadata[infoField.informationfieldId] = localizedValue;
        } else if (infoField.kind === 'DROP_DOWN' && valueControls[i].value != null) {
          metadata[infoField.informationfieldId] = valueControls[i].value.key;
        } else {
          if (valueControls) {
            metadata[infoField.informationfieldId] = valueControls[i].value;
          }
        }
      });
      requestUpload.metadata.push(metadata);
    }
    return requestUpload;
  }

  onSubmit() {
    if (this.isValid() && this.checkFolderValidity()) {
      const requestUpload = this.prepareRequestUpload(null);
      const uploadedFilesIdentifiers = [];
      this.uploadedFiles.filter(uf => uf.status === 'uploaded' || uf.status === 'finishing')
        .forEach(uf => uploadedFilesIdentifiers.push(uf.uploadHandle));
      requestUpload.uplodHandles = requestUpload.uplodHandles.filter(u => uploadedFilesIdentifiers.indexOf(u.handleIdentifier) >= 0);
      this.loading = true;
      this.requestService.finishRequestUsingPOST(requestUpload, this.id).subscribe(res => {
          this.uploadedFiles.filter(uf => uf.status === 'uploaded' || uf.status === 'finishing').forEach(uf => uf.status = 'uploading');
          let duplicatedFiles = 0;
          let uploadedFiles = 0;
          if (this.request.configuration.duplicateHandling === 'DO_NOTHING') {
            this.uploadedFiles.forEach(file => {
              if (file.duplicate > 0) {
                duplicatedFiles++;
              } else {
                uploadedFiles++;
              }
            });
          } else {
            uploadedFiles = this.uploadedFiles.length;
            duplicatedFiles = 0;
          }
          this.dialog.open(UploadedDialogComponent,
            {
              data: {uploaded: uploadedFiles, duplicates: duplicatedFiles, pinLink: res, uploadedText: this.uploadedText},
              disableClose: true
            });
        },
        (err) => {
          this.snackBar.open(this.translatePipe.transform(err.error.title) + ':\n' +
            err.error.message, this.translatePipe.transform('ERROR'), {
            duration: 5000,
            panelClass: ['error-snackbar']
          });
          this.loading = false;
        });
    }
  }

  deleteFile(i: any) {
    if (this.request.configuration.duplicateStrategy === 'DO_NOTHING' ||
      this.request.configuration.duplicateHandling !== 'DO_NOTHING' || this.uploadedFiles[i].duplicate === 0) {
      this.currentlyUploaded--;
    }
    if ((this.uploadedFiles[i].fileEntry['fullPath'] && (this.uploadedFiles[i].fileEntry['fullPath'].split('/').length - 1) > 1)) {
      this.folderUploaded--;
    }
    this.uploadedFiles.splice(i, 1);
    this.uploadHandles.splice(i, 1);
    this.files.splice(i, 1);
    this.dataSource = new MatTableDataSource<UploadFile>(this.uploadedFiles);
  }

  addChildOptions(options, node, parentName, parentNames, noderef) {
    let nodeName;
    if (node.name.values[this.request.configuration.language] !== undefined) {
      nodeName = node.name.values[this.request.configuration.language];
    } else if (node.name.values['en'] !== undefined) {
      nodeName = node.name.values['en'];
    } else {
      nodeName = Object.values(node.name.values)[0];
    }
    let newParentNames;
    if (parentName != null) {
      newParentNames = parentNames;
    } else {
      newParentNames = [];
    }
    const parentNameCopy = JSON.parse(JSON.stringify(parentNames));
    options.push({id: (noderef ? 'id_' : '') + node.id.id, name: nodeName, parents: parentNameCopy});
    if (node.children != null && node.children.length > 0) {
      const newParentNamesCopy = JSON.parse(JSON.stringify(newParentNames));
      newParentNamesCopy.push(nodeName);
      node.children.forEach(child => {
        this.addChildOptions(options, child, nodeName, newParentNamesCopy, noderef);
      });
    }
    return options;
  }

  isValid() {
    let valid = true;
    if (this.autoUpload) {
      if (this.globalUploadedFile && this.globalUploadedFile.valueControls) {
        for (const formControl of this.globalUploadedFile.valueControls) {
          if (formControl !== undefined && formControl.invalid) {
            formControl.markAsTouched();
            formControl.markAsDirty();
            valid = false;
          } else if (Array.isArray(formControl)) {
            if (formControl[this.defaultLanguage] !== undefined && formControl[this.defaultLanguage].invalid) {
              formControl[this.defaultLanguage].markAsTouched();
              formControl[this.defaultLanguage].markAsDirty();
              valid = false;
            }
          }
        }
      }
    } else {
      if ((this.request.configuration.assetSpecificMetadata && !this.sameMetadataEveryAsset) && !this.autoUpload) {
        this.uploadedFiles.forEach(uploadedFile => {
          if (this.request.configuration.informationFields.length > 0) {
            if (uploadedFile.valueControls) {
              for (const formControl of uploadedFile.valueControls) {
                if (Array.isArray(formControl) && formControl != null) {
                  Object.values(formControl).forEach(formControlLocalized => {
                    if (formControlLocalized !== undefined && formControlLocalized.invalid) {
                      formControlLocalized.markAsTouched();
                      formControlLocalized.markAsDirty();
                      valid = false;
                    }
                  });
                } else if (formControl !== undefined && formControl.invalid) {
                  formControl.markAsTouched();
                  formControl.markAsDirty();
                  valid = false;
                }
              }
            }
          }
        });
      } else {
        if (this.uploadedFiles[0] && this.uploadedFiles[0].valueControls && this.uploadedFiles[0].valueControls.length > 0) {
          for (const formControl of this.uploadedFiles[0].valueControls) {
            if (formControl !== undefined && formControl.invalid) {
              formControl.markAsTouched();
              formControl.markAsDirty();
              valid = false;
            } else if (Array.isArray(formControl)) {
              if (formControl[this.defaultLanguage] !== undefined && formControl[this.defaultLanguage].invalid) {
                formControl[this.defaultLanguage].markAsTouched();
                formControl[this.defaultLanguage].markAsDirty();
                valid = false;
              }
            }
          }
        }
      }
    }
    if (!valid) {
      this.snackBar.open(this.translatePipe.transform('FILL_ALL_REQUIRED_FIELDS'), this.translatePipe.transform('INVALID_FORM'), {
        duration: 2000,
      });
    }
    return valid;
  }

  changeLanguage(event) {
    this.translateService.use(event.value);
    this.infoFieldsService.languagesUsingGET(this.request.configuration.language).subscribe(languages => {
      this.metadataLanguages = languages['metadata'];
      this.defaultLanguage = languages['defaultLanguage'];
      this.uploadedText = languages['uploadedText'];
      // tslint:disable-next-line:max-line-length
      this.uploaderInformation = this.sanitizer.bypassSecurityTrustHtml(this.request.configuration.uploaderInformation[this.translateService.currentLang]);
    });
  }

  updateOrder(update: any) {
    if (this.metadataAvailable && (!this.request.configuration.assetSpecificMetadata || this.sameMetadataEveryAsset)) {
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.uploadedFiles.length; i++) {
        this.uploadedFiles[i].valueControls = this.uploadedFiles[0].valueControls;
      }
    }
    if (this.sortRenameConfig) {
      this.uploadHandles = this.sortFilesPipe
        .transform(this.uploadHandles, this.sortRenameConfig.sort, this.sortRenameConfig.sortDirection);
      this.uploadedFiles = this.sortFilesPipe
        .transform(this.uploadedFiles, this.sortRenameConfig.sort, this.sortRenameConfig.sortDirection);
      this.array_move(this.uploadHandles, update['from'], update['to']);
      this.array_move(this.uploadedFiles, update['from'], update['to']);
    }
  }

  array_move(arr, oldIndex, newIndex) {
    this.sortRenameConfig.sort = 'custom';
    if (newIndex >= arr.length) {
      let k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  }

  private submitFile(index, res) {
    const requestUpload = this.prepareRequestUpload(res);
    this.requestService.finishRequestUsingPOST(requestUpload, this.id).subscribe(result => {
      this.uploadedFiles[index].status = 'finished';
    });
  }

  autoUploadToggle() {
    const uploadFile = new class implements UploadFile {
      file: File;
      directoryEntry: FileSystemDirectoryEntry;
      fileEntry: FileSystemFileEntry;
      path: string;
      status: string;
      type: string;
      uploadHandle: string;
      duplicate: number;
      progress = 0;
      valueControls: FormControl[];
      configuration: Configuration;
    }();
    uploadFile.type = 'file';
    uploadFile.status = 'pending';
    uploadFile.configuration = JSON.parse(JSON.stringify(this.request.configuration));
    if (!this.autoUpload) {
      this.globalUploadedFile = uploadFile;
      this.sameMetadataEveryAsset = false;
      this.autoUpload = true;
      if (this.isValid()) {
        this.autoUploadActivated = true;
      }
      for (let i = 0; i < this.uploadedFiles.length; i++) {
        this.submitFile(i, {identifier: this.uploadedFiles[i].uploadHandle});
      }

    } else {
      this.autoUpload = false;
      if (this.uploadedFiles[0]) {
        this.uploadedFiles[0].valueControls = uploadFile.valueControls;
      }
    }
  }

}

